import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getDeptMngList({ searchParams, currentPage, pageUnit }) {
		let queryStr = '';
		if (searchParams.deptCd !== undefined || searchParams.deptNm !== undefined) {
			queryStr = objectToQueryString({
				deptCd: searchParams.deptCd,
				deptNm: searchParams.deptNm,
				currentPage,
				pageUnit
			});
		}
		try {
			const response = await client.get(`${BASE_URL}/comm/qmsbase/deptMng/v1/dept${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	postDeptManagement: param => {
		//console.log('debug', param);
		return client
			.post(`${BASE_URL}/comm/qmsbase/deptMng/v1/status/${param.status}`, param.data)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
